import { Container, Text } from '@ahc-digital/component-library';
import { PropsWithChildren } from 'react';

/** Use this component to display a prompt to the author to switch to Preview Mode to view the component as-designed.
 * This is useful when the component is given a different appearance in Experience Editor in order to make the editing experience easier.
 */
export const SwitchToPreviewMessage = (props?: PropsWithChildren & { componentName?: string }) => (
  <>
    <Container backgroundColor="cchaPurple">
      <div
        style={{
          textAlign: 'center',
          paddingBlock: '1rem',
        }}
      >
        <Text fontStyle="smParagraph">
          Switch to Preview Mode to view <b>{props?.componentName}</b> as-designed.
        </Text>
      </div>
    </Container>
    {props?.children}
  </>
);
